(() => {
  'use strict';
  function init(root) {
    if (root.dataset.productFormReady) return;
    const dataNode = root.querySelector('[data-native-product-data]');
    if (!dataNode) return;
    let data;
    try { data = JSON.parse(dataNode.textContent); } catch { return; }
    const variantInput = root.querySelector('#native-variant');
    const planSelect = root.querySelector('#native-selling-plan');
    const plansBox = root.querySelector('[data-native-plans]');
    const planLabel = plansBox?.querySelector('label');
    const planNote = root.querySelector('[data-native-plan-note]');
    const planError = root.querySelector('[data-native-plan-error]');
    const price = root.querySelector('#native-price');
    const unitPrice = root.querySelector('#native-unit-price');
    const buy = root.querySelector('#native-buy');
    if (!variantInput || !planSelect || !plansBox || !buy || !price) return;
    root.dataset.productFormReady = 'true';
    const initial = window.CatalogOptions?.defaultVariant(data, new URL(window.location.href).searchParams.get('variant'));
    if (initial) variantInput.value = String(initial.id);
    const getVariant = () => data.variants.find(v => String(v.id) === variantInput.value);
    function updatePrice() {
      const variant = getVariant();
      if (!variant) { buy.disabled = true; buy.textContent = 'Unavailable'; price.textContent = '—'; if (planError) planError.hidden = false; return; }
      const plan = planSelect.disabled ? null : variant.plans.find(p => String(p.id) === planSelect.value);
      price.textContent = plan?.price || variant.price;
      if (unitPrice) unitPrice.textContent = plan?.unitPrice || variant.unitPrice || '';
      const invalidPlan = variant.requiresPlan && !plan;
      buy.disabled = !variant.available || invalidPlan;
      buy.textContent = variant.available ? 'Add to bag ' : 'Sold out';
      if (planError) planError.hidden = !invalidPlan;
    }
    function updatePlans(preferredPlan) {
      const variant = getVariant();
      if (!variant) { buy.disabled = true; buy.textContent = 'Unavailable'; price.textContent = '—'; if (planError) planError.hidden = false; return; }
      const plans = variant.plans || [];
      const enabled = plans.length > 0 && (variant.requiresPlan || data.showOptionalPlans);
      plansBox.hidden = !enabled;
      planSelect.disabled = !enabled;
      planSelect.replaceChildren();
      const option = (value, name) => {
        const node = document.createElement('option');
        node.value = String(value); node.textContent = name;
        planSelect.appendChild(node);
      };
      if (enabled) {
        if (!variant.requiresPlan) option('', 'One-time purchase');
        plans.forEach(p => option(p.id, p.name));
        planSelect.value = plans.some(p => String(p.id) === preferredPlan)
          ? preferredPlan : variant.requiresPlan ? String(plans[0].id) : '';
      }
      const soleRequiredPlan = enabled && variant.requiresPlan && plans.length === 1;
      planSelect.hidden = soleRequiredPlan;
      if (planLabel) planLabel.hidden = soleRequiredPlan;
      if (planNote) { planNote.hidden = !soleRequiredPlan; planNote.textContent = soleRequiredPlan ? plans[0].name : ''; }
      updatePrice();
    }
    function updateUrl() {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantInput.value);
      if (!planSelect.disabled && planSelect.value) url.searchParams.set('selling_plan', planSelect.value);
      else url.searchParams.delete('selling_plan');
      window.history.replaceState(null, '', url);
    }
    const picker = window.CatalogOptions?.mount({container:root.querySelector('[data-native-option-picker]'),master:variantInput,variants:data.variants,options:data.options,onChange:()=>{updatePlans(planSelect.value);updateUrl();}});
    variantInput.addEventListener('change', () => { picker?.sync(variantInput.value); updatePlans(planSelect.value); updateUrl(); });
    planSelect.addEventListener('change', () => { updatePrice(); updateUrl(); });
    updatePlans(new URL(window.location.href).searchParams.get('selling_plan') || planSelect.value);
  }
  document.querySelectorAll('[data-native-product]').forEach(init);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-native-product]').forEach(init);
  });
})();
